import { ReducerStateFactory } from './state-factory.reducer';

import * as actions from '../actions/index';
import { OrganisationFeedbackInterface } from '@careapp/angular-sdk';

export class FeedbackReducer extends ReducerStateFactory<OrganisationFeedbackInterface> {}

export const state = new FeedbackReducer(actions.Feedback);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
